import { useMemo } from 'react';

const useServicesList = ({
  services,
  selectionProps,
  onDelete,
  toggleServiceFormModal
}) => {
  const servicesList = useMemo(() => {
    return services.map(service => ({
      ...service,
      onEdit: () => toggleServiceFormModal(service),
      onDelete: () => onDelete(service),
      ...(selectionProps && {
        isChecked: selectionProps.selectedIds?.includes(service.id),
        onCheck: isSelected =>
          selectionProps.toggleSelection?.(service, isSelected)
      })
    }));
  }, [services, selectionProps]);

  const filteredList = useMemo(() => {
    return servicesList.filter(service =>
      selectionProps?.isSelectedOnly ? service.isChecked : true
    );
  }, [servicesList, selectionProps?.isSelectedOnly]);

  return filteredList;
};

export default useServicesList;
